import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { LanguageSelectionModalComponent } from './language-selection-modal.component';

export interface LanguageSelectionPayload {
  continueEvent?: () => void;
  cancelEvent?: () => void;
  messageExplain?: string;
}

export function languageSelectionModalParts(payload?: LanguageSelectionPayload): ModalBlockParts {
  return {
    id: 'LanguageSelectionModalComponent',
    block: LanguageSelectionModalComponent,
    closeBackEnable: false,
    type: ModalType.TYPE2,
    modalWidth: LModalContentsWidthType.MODAL_PC_W1000,
    payload: payload,
  };
}
